angular
	.module 'App.Module.TenderTypes', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'tendertypes',
				url: '/tendertypes',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'
					'entity_search@tendertypes':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					searchParams:
						repositoryName: 'TenderTypeRepository'
						title: 'general.tendertypes'

			.state 'tendertypes.edit',
				abstract: true,
				url: '/:id'
				views:
					'entity_view':
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					tenderType: (TenderTypeRepository, $stateParams) ->
						return TenderTypeRepository.getEntity $stateParams.id

			.state 'tendertypes.edit.details',
				url: '/details',
				views:
					'entity_sub_view':
						controller: 'TenderTypeController'
						controllerAs: 'vm'
						templateUrl: '@app/tender-type/tender-type.view.html'
